import { useExperiment } from '@mc/api-hooks'

// https://app.growthbook.io/features/g_enterprise_announcement
const FLAG_NAME = 'g_enterprise_announcement'

export const useIsEnterpriseAnnouncementEnabled = () => {
  const {
    data: enterpriseAnnouncementFF,
    isLoading: enterpriseAnnouncementEnabledLoading,
  } = useExperiment(FLAG_NAME)

  return {
    enterpriseAnnouncementEnabledLoading,
    enterpriseAnnouncementEnabled: enterpriseAnnouncementFF === 'variant_1',
  }
}
